// extracted by mini-css-extract-plugin
module.exports = {"DarkModeSlider":"DarkModeSlider_DarkModeSlider__2TSGC"};